import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { ApartmentDTO } from '../../../model/ApartmentDTO';

@Block() @Component
export class ApartmentAdditionalCostFeaturesBlock extends BaseBlock {
	expand: boolean = !this.$store.isTouchDevice;
	isTouchDevice: boolean = this.$store.isTouchDevice;

	@Prop() apartment: ApartmentDTO;

	get additionalCostFeaturesList() {
		return (this.apartment.additionalCostFeaturesList || '').split('\n').filter(s => s.trim().length > 0);
	}

	//created() {
	//	const mql = window.matchMedia("(pointer: coarse)");
		
	//	this.expand = !mql.matches
	//	this.isTouchDevice = mql.matches
	//}
}

export default ApartmentAdditionalCostFeaturesBlock;
